import { Calendar, Search } from "lucide-react";
import { Button, Input, Label } from "@/components/ui";

interface OrderHistoryFiltersProps {
  search: string;
  onSearchChange: (value: string) => void;
  startDate: string;
  onStartDateChange: (value: string) => void;
  endDate: string;
  onEndDateChange: (value: string) => void;
  onClear: () => void;
}

export function OrderHistoryFilters({
  search,
  onSearchChange,
  startDate,
  onStartDateChange,
  endDate,
  onEndDateChange,
  onClear,
}: OrderHistoryFiltersProps) {
  const hasAnyFilter = startDate || endDate || search;

  return (
    <div className="flex flex-col gap-3 rounded-lg border bg-background p-4 sm:flex-row sm:items-end">
      <div className="flex-1">
        <Label className="mb-1.5 block text-xs text-muted-foreground">
          Search
        </Label>
        <div className="relative">
          <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
          <Input
            placeholder="Order #, customer, or product (e.g. latte)"
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
            className="pl-9"
          />
        </div>
      </div>
      <div>
        <Label className="mb-1.5 block text-xs text-muted-foreground">
          <Calendar className="mr-1 inline h-3 w-3" />
          From
        </Label>
        <Input
          type="date"
          value={startDate}
          onChange={(e) => onStartDateChange(e.target.value)}
          className="w-36"
        />
      </div>
      <div>
        <Label className="mb-1.5 block text-xs text-muted-foreground">
          <Calendar className="mr-1 inline h-3 w-3" />
          To
        </Label>
        <Input
          type="date"
          value={endDate}
          onChange={(e) => onEndDateChange(e.target.value)}
          className="w-36"
        />
      </div>
      {hasAnyFilter && (
        <Button variant="ghost" size="sm" onClick={onClear}>
          Clear
        </Button>
      )}
    </div>
  );
}
